/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.SearchKeywords";
        class SearchKeywordsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("SearchKeywordsWidgetTypeClass.createInstance()");
                    return new SearchKeywordsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("SearchKeywordsWidgetTypeClass._storeHtml()");
                    SearchKeywordsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("SearchKeywordsWidgetTypeClass::constructor");
                if (SearchKeywordsWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/SearchKeywords/search-keywords.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.SearchKeywordsWidgetTypeClass = SearchKeywordsWidgetTypeClass;
        class SearchKeywordsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._stealthHideButton = null;
                this._editContainer = null;
                this._clearButton = null;
                this._searchButton = null;
                this._kwComponentContainer = null;
                this._kwComponent = null;
                // Management
                this._reactToQuery = true;
                this._reactToDocType = true;
                this._publishAs = 'Definition';
                this._defaultDateOptionQuery = 'none';
                this._defaultDateOptionDocType = 'none';
                this._simpleEditors = false;
                // State info
                this._collapseState = "Show";
                this.presentInstance = () => {
                    this._log.info("SearchKeywordsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = SearchKeywordsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._kwComponentContainer = this._container.querySelector('#searchKeysKeywordsComponent');
                    this._stealthHideButton = this._container.querySelector('#searchKeysStealthButton');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    this._core.Helper.setElementTranslationAttribute(this._stealthHideButton, 'title', 'STR_WPT_HIDE');
                    // Edit controls
                    this._editContainer = this._container.querySelector('#searchKeysEditControls');
                    this._clearButton = this._container.querySelector('#searchKeysClearBtn');
                    this._clearButton.addEventListener('click', this._clearEntries);
                    this._core.Helper.setElementTranslation(this._clearButton.querySelector('#searchKeysClearBtnLabel'), 'STR_WPT_CLEAR');
                    this._searchButton = this._container.querySelector('#searchKeysSearchBtn');
                    this._searchButton.addEventListener('click', this._executeSearch);
                    this._core.Helper.setElementTranslation(this._searchButton.querySelector('#searchKeysSearchBtnLabel'), 'STR_WPT_SEARCH');
                    this._widgets.setTitle(this._config, this._container.querySelector('#searchKeysHeading'), 'STR_WPT_KEYWORDS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    let conf = this._config;
                    if (conf.hasOwnProperty('ReactToQuery') && (conf.ReactToQuery != null))
                        this._reactToQuery = conf.ReactToQuery;
                    if (conf.hasOwnProperty('ReactToDocumentType') && (conf.ReactToDocumentType != null))
                        this._reactToDocType = conf.ReactToDocumentType;
                    if (conf.hasOwnProperty('PublishAs') && (conf.PublishAs != null))
                        this._publishAs = conf.PublishAs;
                    if (conf.hasOwnProperty('QueryDefaultDateOption') && (conf.QueryDefaultDateOption != null))
                        this._defaultDateOptionQuery = conf.QueryDefaultDateOption;
                    if (conf.hasOwnProperty('DocTypeDefaultDateOption') && (conf.DocTypeDefaultDateOption != null))
                        this._defaultDateOptionDocType = conf.DocTypeDefaultDateOption;
                    if (conf.hasOwnProperty('SimpleKeywordEditors') && (conf.SimpleKeywordEditors != null))
                        this._simpleEditors = conf.SimpleKeywordEditors;
                    if (conf.hasOwnProperty('CollapseState') && (conf.CollapseState != null))
                        this._collapseState = conf.CollapseState;
                    if (this._collapseState == "Stealth")
                        this._core.Functions.showElement(this._stealthHideButton);
                    this._kwComponent = new Widgets.ComponentKeywordsSearch(this._core, this._kwComponentContainer, this);
                    this._kwComponent.ErrorCallback = this._callErrorHandler;
                    this._kwComponent.FailCallback = this._callFailedHandler;
                    this._kwComponent.present();
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._clearEntries = () => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._clearEntries()");
                    this._kwComponent.clearValues();
                };
                this._showKeysForQuery = (qId, simpleEditors = false, dateOption = null) => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._showKeysForQuery()");
                    let query = this._core.OBHelper.CustomQueries.find(cq => (cq.Id == qId));
                    if (query) {
                        let kwCompRequest = {
                            QueryName: query.Name,
                            DateOption: (dateOption) ? dateOption : this._defaultDateOptionQuery,
                            SimpleEditors: simpleEditors,
                            KeyUpHandler: this._executeSearchOnEnter
                        };
                        this._kwComponent.makeRequest(kwCompRequest);
                        this._core.Functions.showElement(this._editContainer);
                    }
                    else
                        this.addError(`Invalid custom query ID requested (${qId}).`);
                };
                this._showKeysForDocTypes = (docTypes, simpleEditors = false, dateOption = null) => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._showKeysForDocTypes()");
                    let kwCompRequest = {
                        DocTypes: [],
                        DateOption: (dateOption) ? dateOption : this._defaultDateOptionDocType,
                        SimpleEditors: simpleEditors
                    };
                    docTypes.forEach(dt => {
                        kwCompRequest.DocTypes.push(dt.Name);
                    });
                    if (kwCompRequest.DocTypes.length > 0) {
                        kwCompRequest.KeyUpHandler = this._executeSearchOnEnter;
                    }
                    this._kwComponent.makeRequest(kwCompRequest);
                    this._core.Functions.showElement(this._editContainer);
                };
                this._executeSearchOnEnter = (event) => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._executeSearchOnEnter()");
                    if (event.key === "Enter") {
                        // not using "_executeSearch()" directly on purpose, editor won't have the current value => needs a change event
                        this._searchButton.focus();
                        this._searchButton.click();
                    }
                };
                this._executeSearch = () => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._executeSearch()");
                    if (this._kwComponent.Valid) {
                        if (this._publishAs == 'Definition')
                            this._publishQueryDefinition(this._kwComponent.FlexSearchDef);
                        else {
                            let request = { SearchDefinition: this._kwComponent.FlexSearchDef };
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(request), this._hitListReceived, {}, this._callErrorHandler, this._callFailedHandler);
                        }
                    }
                    else
                        this._core.Helper.presentWarningModal('STR_WPT_REQUIRED_SEARCH_KEYS_MISSING');
                };
                this._publishQueryDefinition = (criteria) => {
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_DEFINITION);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = criteria;
                    let targetLayoutName = this._currentLayout;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._hitListReceived = (response) => {
                    
                    let hitList = (response.hasOwnProperty('Documents') && (response.Documents != null)) ? response.Documents : [];
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = hitList;
                    let targetLayoutName = this._currentLayout;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._stealthHide = (event) => {
                    this._log.info("SearchKeywordsWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("SearchKeywordsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("SearchKeywordsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                // Don't respond to update events, we are directy working for another widget
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_SELECTED:
                        if (this._reactToQuery) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                let simple = (context.AdditionalContext.hasOwnProperty('SimpleKeywordEditors') && context.AdditionalContext.SimpleKeywordEditors != null)
                                    ? context.AdditionalContext.SimpleKeywordEditors : this._simpleEditors;
                                let dateOpt = (context.AdditionalContext.hasOwnProperty('DefaultDateOption') && context.AdditionalContext.DefaultDateOption != null)
                                    ? context.AdditionalContext.DefaultDateOption : this._defaultDateOptionQuery;
                                this._showKeysForQuery(context.ActivationID, simple, dateOpt);
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_DESELECTED:
                        if (this._reactToQuery) {
                            if ((this._collapseState == "Stealth") && !this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS))
                                this._core.Functions.hideElement(this._outerDiv);
                            this._kwComponent.clearDisplay();
                            this._core.Functions.hideElement(this._editContainer);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCTYPES_SELECTED_SEARCH:
                        if (this._reactToDocType) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                let simple = (context.AdditionalContext.hasOwnProperty('SimpleKeywordEditors') && context.AdditionalContext.SimpleKeywordEditors != null)
                                    ? context.AdditionalContext.SimpleKeywordEditors : this._simpleEditors;
                                let dateOpt = (context.AdditionalContext.hasOwnProperty('DefaultDateOption') && context.AdditionalContext.DefaultDateOption != null)
                                    ? context.AdditionalContext.DefaultDateOption : this._defaultDateOptionDocType;
                                this._showKeysForDocTypes(context.PrimaryContext, simple, dateOpt);
                                if (context.PrimaryContext.length == 0)
                                    this._core.Functions.hideElement(this._editContainer);
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_DESELECTED:
                        if (this._reactToDocType) {
                            if ((this._collapseState == "Stealth") && !this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS))
                                this._core.Functions.hideElement(this._outerDiv);
                            this._kwComponent.clearDisplay();
                            this._core.Functions.hideElement(this._editContainer);
                        }
                        break;
                }
            }
        }
        SearchKeywordsWidgetInstanceClass.HtmlData = null;
        Widgets.SearchKeywordsWidgetInstanceClass = SearchKeywordsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
